import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/AIML/QuantAnalysisUpload";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const QuantAnalysisUploadMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="QuantAnalysisUpload">
      <MobileNotice page="QuantAnalysisUpload" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default QuantAnalysisUploadMobile;